import CoverageAppState from "../interfaces/CoverageAppState";
import Action from "../interfaces/Action";
import TabName from "../interfaces/TabName";
import { actions } from "./actions";

const initialState: CoverageAppState = {
  coverages: [],
  updated: [],
  allCoverageListIsLoading: false,
  selectedCoverage: [],
  displayCoverageId: "",
  categories: [],
  selectedPageId: 0,
  visibleTabName: TabName.Document,
  displayTooltip: false,
  displayModal: false,
  editedCategoryName: "",
  selectedCategoryId: "",
  displayCreateModal: false,
  newCategoryName: "",
  displayFunctionsToolbar: false,
  toastBarType: "info",
  toastBarMessage: "",
  displayToastBar: false,
  hasNoSearchHits: false,
};

const reducer = (state = initialState, action: Action): CoverageAppState => {
  switch (action.type) {
    case actions.setVisibleTabName:
      return { ...state, visibleTabName: action.payload };
    case actions.setAllCategories:
      return { ...state, categories: action.payload };
    case actions.setAllCoverages:
      return { ...state, coverages: action.payload };
    case actions.setAllUpdated:
      return { ...state, updated: action.payload };
    case actions.toggleModal:
      return { ...state, displayModal: !state.displayModal };
    case actions.toggleTooltip:
      return { ...state, displayTooltip: !state.displayTooltip };
    case actions.setSelectedPageId:
      return { ...state, selectedPageId: action.payload };
    default:
      return state;
  }
};

export default reducer;
